// @flow
import {call, put, select} from 'redux-saga/effects';
import {
  customerSelector,
  customerTaxExemptionsSelector,
} from '../../Customer/selectors';
import {setOrderUuid} from '../Order';

import Trpc from 'digicel-kaizen-library/lib/tripica-library';
import {tripica} from '../../../api';
import config from '../../../config';
import {voucherCurrentVoucherDetailsSelector} from '../../Voucher';
import {deliveryAddressSelector} from '../DeliveryAddress/reducer';
import {deliveryContactSelector} from '../DeliveryContact/reducer';
import {deliveryMethodSelector} from '../DeliveryMethod/selectors';

export function* orderSimAPICall(): Generator<*, *, *> {
  let customer = yield select(customerSelector);

  const deliveryAddress = yield select(deliveryAddressSelector);
  const deliveryContact = yield select(deliveryContactSelector);
  if (deliveryContact && !deliveryContact.phoneNumber && customer) {
    deliveryContact.phoneNumber = customer.contactNumber;
  }
  let deliveryCharacteristics;
  if (config.canChooseDeliveryMethod) {
    const deliveryMethod = yield select(deliveryMethodSelector);
    deliveryCharacteristics =
      deliveryMethod &&
      Trpc.buildDeliveryCharacteristics(
        deliveryAddress,
        {...deliveryContact},
        deliveryMethod.characteristics,
      );
  } else {
    deliveryCharacteristics = Trpc.buildDeliveryCharacteristics(
      deliveryAddress,
      {...deliveryContact},
    );
  }

  const catalog = yield call([tripica, 'getCatalog']);

  const taxExemptions = yield select(customerTaxExemptionsSelector);
  const billingAccountOuid = customer.billingAccounts.find(
    billingAccount => billingAccount.billFormat === 'CUSTOMER_ACCOUNT',
  ).ouid;

  // Handling voucher if any selected
  const voucherDetails = yield select(voucherCurrentVoucherDetailsSelector);

  let response;

  response = yield call(
    [tripica, 'orderSim'],
    customer.ouid,
    billingAccountOuid,
    'unused',
    catalog,
    deliveryCharacteristics,
    taxExemptions,
    voucherDetails,
  );

  if (response && response.status !== 'NOT_STORED') {
    yield put(setOrderUuid(response && response.uuid));
  }

  return response;
}
